module.exports = __webpack_public_path__ + "static/media/Woodlands-South-Condos.6b05dafd.pdf";